import { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { generateIdeaBatch } from '../api'
import { INITIAL_STAGES, StageList, useGenerationProgress } from '../components/ProgressStages'
import { celebrateBurst } from '../components/GameFx'
import { celebrateBurst as celebrate } from '../components/GameFx'

export default function CreatePage() {
  const navigate = useNavigate()
  const [input, setInput] = useState('')
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState('')
  const { stages, elapsedMs, setStage, startTimer, stopTimer, reset } = useGenerationProgress()
  const [showProgress, setShowProgress] = useState(false)

  async function onSubmit(e: React.FormEvent) {
    e.preventDefault()
    const text = input.trim()
    if (!text) {
      setError('请输入游戏构想')
      return
    }
    setLoading(true)
    setError('')
    setShowProgress(true)
    reset()
    startTimer()
    setStage('analyze', 'active', '理解你的构想…')
    await new Promise((r) => setTimeout(r, 200))
    setStage('analyze', 'done')
    setStage('ideas', 'active', 'DeepSeek 生成中')

    try {
      const result = await generateIdeaBatch(text)
      if (!result.batch?.id) {
        setStage('ideas', 'fail', result.error || '失败')
        setError(result.error || '生成失败，请稍后重试')
        stopTimer()
        setLoading(false)
        return
      }
      setStage('ideas', 'done', '已得到 3 个方案')
      setStage('save', 'active', '写入历史')
      setStage('save', 'done', '文字历史已保存')
      celebrateBurst()
      celebrate()
      // 文字完成后立刻展示结果，并自动进入生图
      stopTimer()
      navigate(`/result/${result.batch.id}`, { state: { autoImage: true, batch: result.batch } })
    } catch (err) {
      setStage('ideas', 'fail')
      setError(err instanceof Error ? err.message : '网络错误')
      stopTimer()
    } finally {
      setLoading(false)
    }
  }

  return (
    <section className="section">
      <h2>GAME IDEA GENERATOR</h2>
      <p className="muted" style={{ marginBottom: '1.25rem' }}>
        输入游戏构想，一次得到 <strong>3 个玩法不同</strong> 的方案，并自动为第一个方案生成一张像素概念图（每批 1 次）。
      </p>

      {error ? <div className="alert alert-error">{error}</div> : null}

      <form className={`panel pixel-frame${loading ? ' is-loading' : ''}`} onSubmit={onSubmit}>
        <div className="field">
          <label htmlFor="idea">游戏构想 *</label>
          <textarea
            id="idea"
            value={input}
            maxLength={4000}
            onChange={(e) => setInput(e.target.value)}
            placeholder="例如：我想做一个像素风的 2D 种田游戏，但是希望加入地下城探索和经营玩法。"
            rows={8}
            disabled={loading}
          />
          <span className="hint">一句话或详细描述均可（最多 4000 字）。</span>
        </div>

        <div className="form-actions">
          <button className="btn btn-primary" type="submit" disabled={loading}>
            {loading ? '生成中…' : '生成游戏创意'}
          </button>
          <span className="hint" style={{ width: '100%', marginTop: '0.35rem' }}>
            自动生成 3 个方案并生成展示图
          </span>
          <button className="btn btn-ghost" type="button" disabled={loading} onClick={() => setInput('')}>
            清空
          </button>
        </div>

        {showProgress ? <StageList stages={stages.length ? stages : INITIAL_STAGES} elapsedMs={elapsedMs} /> : null}
      </form>
    </section>
  )
}
